import React, { useState } from "react";
import Header from "../common/Header";
import BlogsData from "./BlogsData";

const MyBlogs = () => {
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl overflow-x-hidden  h-[calc(100vh-32px)]">
        <div className=" px-5 relative  overflow-hidden pb-3">
          <div className=" overflow-hidden">
            <Header text="Blog" />
          </div>
          <div className="w-full">
            <BlogsData />
          </div>
        </div>
      </div>
    </>
  );
};

export default MyBlogs;
